import { Payment } from '@repo-level/core-front';
import { ScPaymentMethodCardMobile } from './styled';

interface PaymentMethodCardProps {
  method: Payment.Method;
  index: number;
  onSelect: (method: Payment.Method) => void;
}

export const PaymentMethodCardMobile = ({
  method,
  index,
  onSelect,
}: PaymentMethodCardProps) => {
  const { iconSrc, translationKey, id } = method;

  return (
    <ScPaymentMethodCardMobile>
      <button onClick={() => onSelect(method)} key={`${id}_${index}`}>
        {iconSrc && (
          <img
            src={iconSrc}
            alt={`${translationKey} logo`}
            width={92}
            height={32}
          />
        )}
      </button>
    </ScPaymentMethodCardMobile>
  );
};
